export default __webpack_public_path__ + "static/media/step4.154fb954.jpg";